import styled from '@emotion/styled';
import { breakpoints } from '@naf/theme';

export const DesktopWrapper = styled.div`
  display: flex;
  margin-left: -16px;
  margin-top: -2px;

  svg {
    width: 100%;
    height: 100%;
  }

  @media (max-width: ${breakpoints.m}) {
    display: none;
  }
`;

export const MobileWrapper = styled.div`
  display: none;

  @media (max-width: ${breakpoints.m}) {
    display: flex;
    margin-top: -2px;

    svg {
      width: 100%;
      height: 100%;
    }
  }

  @media (max-width: ${breakpoints.m}) {
    display: flex;
  }
`;
